import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { history } from '@LIBS';
import App from './App';
import { SWRConfig } from 'swr';
import 'moment/locale/tr';
import locale from 'antd/lib/locale/tr_TR';
import { AppProvider, AuthProvider } from '@CONTEXTS';


if (process.env.NODE_ENV==='development'){
   // Server();
}

ReactDOM.render(
  <AppProvider>
    <Router history={history}>
      <ConfigProvider locale={locale}>
        <SWRConfig
          value={{
            // fetcher,
            // revalidateOnMount: false,
            revalidateOnFocus: false,
            shouldRetryOnError: false,
            onErrorRetry: false,
          }}
        >
          <AuthProvider>
            <App />
          </AuthProvider>
        </SWRConfig>
      </ConfigProvider>
    </Router>
  </AppProvider>,

  document.getElementById('root')
);
